import React, { useCallback, useEffect } from "react";
import { useIntl } from "react-intl";
import { useDispatch } from "react-redux";
import { Outlet, useLocation } from "react-router-dom";
import { getContent, getContentBySlug } from "./api/sanity/utils";
import {
  CustomScrollTop,
  NewHeader,
  Footer,
  Nav,
  ScrollToTop,
  Breadcrumbs,
  CookieConsent,
} from "./components";

import { useLanguage } from "./context";
import { useLanguageSync } from "./hooks/useLanguageSync";
import {
  getTitle,
  queryAndSet,
  useDocumentTitle,
} from "./helpers/utils";
import { setFooterData } from "./redux/reducers/footer";
import { setContactusData } from "./redux/reducers/contactus";
import { setMenuData } from "./redux/reducers/menu";
import { setNewsDefaultData } from "./redux/reducers/newsDefault";
import { setNewletterData } from "./redux/reducers/newletter";

function App() {
  const { pathname } = useLocation();
  const intl = useIntl();
  const { language } = useLanguage();
  const { syncLanguageWithURL } = useLanguageSync();
  const dispatch = useDispatch();

  const getData = useCallback(async (language, pathname) => {
    // const qs = await queryAndSet(pathname);
    // if (qs) {
    //   const data = await getContent(
    //     language,
    //     qs.query,
    //     qs?.slug,
    //     qs?.slugMenu,
    //     qs?.sulgSubMmenu
    //   );
    //   if (data && qs?.setData) {
    //     dispatch(qs.setData(data));
    //     dispatch(setFooterData(data?.footer));
    //     if (data?.contact) dispatch(setContactusData(data?.contact));
    //     if (data?.menus) dispatch(setMenuData(data?.menus));
    //     if (data?.newsDefault) dispatch(setNewsDefaultData(data?.newsDefault));
    //     if (data?.newletter) dispatch(setNewletterData(data?.newletter));
    //   }
    // }
  }, []);

  useEffect(() => {
    syncLanguageWithURL();
    getData(language, pathname);
  }, [pathname, syncLanguageWithURL, getData, language]);

  useEffect(() => {
    if (pathname === "/") {
      getData(language, pathname);
    }
  }, [language, pathname]);

  useDocumentTitle(`Africa Systems | ${getTitle(intl, pathname)}`);

  return (
    <main className="flex flex-col h-full">
      <ScrollToTop />
      <NewHeader />
      {/* <Nav /> */}
      <div>
        <Breadcrumbs />
        <Outlet />
      </div>
      <Footer />
      <CustomScrollTop />
      <CookieConsent />
    </main>
  );
}

export default App;
